"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateDonorFees = void 0;
const constants_1 = require("../constants");
const enums_1 = require("../types/enums");
const utils_1 = require("../utils");
const calculateDonorFeesCAF_1 = require("./calculateDonorFeesCAF");
const calculateDonorFeesGive2Asia_1 = require("./calculateDonorFeesGive2Asia");
const calculateDonorFeesPayPal_1 = require("./calculateDonorFeesPayPal");
const calculateDonorFeesStripe_1 = require("./calculateDonorFeesStripe");
const calculateSimpleFees_1 = require("./calculateSimpleFees");
const feeStructure_1 = require("./feeStructure");
const calculateDonorFees = ({ amount = 0, coverFees = false, donationProvider, nonprofitCountryCode = 'US', cardCountryCode = 'US', isRecurring = false, feeCoveredBy = enums_1.FeeCoveredBy.User, isSandbox, applicationFeeSetting = constants_1.DEFAULT_APPLICATION_FEE_EMPLOYEE, applicationFeeAmountCap, }) => {
    // TODO-AC: Find out and comment why we ignore coverFeesParam for FeeCoveredBy.Deed and FeeCoveredBy.Company
    const coverFeesActual = feeCoveredBy === enums_1.FeeCoveredBy.Deed || feeCoveredBy === enums_1.FeeCoveredBy.Company ? false : coverFees;
    const donorFeesCalculationBaseInput = {
        amount,
        cardCountryCode,
        nonprofitCountryCode,
        coverFees: coverFeesActual,
        applicationFeeSetting,
        applicationFeeAmountCap,
        isSandbox,
        feeCoveredBy,
    };
    // This `if` is there for documenting purpose, to know what providers are unhandled
    if (donationProvider === enums_1.DonationProvider.Betterplace ||
        donationProvider === enums_1.DonationProvider.External ||
        donationProvider === enums_1.DonationProvider.DCGF) {
        throw new Error(`Donation provider ${donationProvider} is not supported for fees calculation`);
    }
    if (donationProvider === enums_1.DonationProvider.Stripe) {
        return (0, calculateDonorFeesStripe_1.calculateDonorFeesStripe)({ ...donorFeesCalculationBaseInput });
    }
    if (donationProvider === enums_1.DonationProvider.PayPal) {
        return (0, calculateDonorFeesPayPal_1.calculateDonorFeesPayPal)({ ...donorFeesCalculationBaseInput, donationProvider, isRecurring });
    }
    if (donationProvider === enums_1.DonationProvider.CAF) {
        return (0, calculateDonorFeesCAF_1.calculateDonorFeesCAF)({ ...donorFeesCalculationBaseInput, donationProvider, isRecurring });
    }
    if (donationProvider === enums_1.DonationProvider.Give2Asia) {
        return (0, calculateDonorFeesGive2Asia_1.calculateDonorFeesGive2Asia)({ ...donorFeesCalculationBaseInput, donationProvider, isRecurring });
    }
    const providerFeeRate = (0, feeStructure_1.feeStructure)({ donationProvider }).relative;
    // @NOTE-AT: NFG fees are added to the total of the transaction using their coverFee: 'Add' model
    // Do not calculate Fees from the Gross Amount
    // see: https://github.com/joindeed/api/pull/1028#discussion_r706856074
    if (donationProvider === enums_1.DonationProvider.NFG) {
        const providerFeeAmountFloat = (0, calculateSimpleFees_1.calculateSimpleFee)({ amount, relative: providerFeeRate, coverFees: false });
        const providerFeeAmount = (0, utils_1.roundNumber)(providerFeeAmountFloat, 2);
        return {
            providerFeeAmount,
            applicationFeeAmount: 0,
            totalFeeAmount: providerFeeAmount,
        };
    }
    if (donationProvider === enums_1.DonationProvider.GlobalGiving || donationProvider === enums_1.DonationProvider.GiveIndia) {
        const providerFeeAmountFloat = (0, calculateSimpleFees_1.calculateSimpleFee)({
            amount,
            relative: providerFeeRate,
            coverFees: coverFeesActual,
        });
        const providerFeeAmount = (0, utils_1.roundNumber)(providerFeeAmountFloat, 2);
        return {
            providerFeeAmount,
            applicationFeeAmount: 0,
            totalFeeAmount: providerFeeAmount,
        };
    }
    // just checking we're not supposed to get there according to Typescript
    (0, utils_1.isNever)(donationProvider);
    throw new Error(`Donation provider ${donationProvider} is not supported for fees calculation`);
};
exports.calculateDonorFees = calculateDonorFees;
//# sourceMappingURL=calculateDonorFees.js.map